<!-- Deprecated in favour of separate files for SMS and Whatsapp and also to implement new providers for each platform in the future-->
<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';
import NextInput from 'dashboard/components-next/input/Input.vue';
import { isPhoneE164OrEmpty } from 'shared/helpers/Validators';
import { parseAPIErrorResponse } from 'dashboard/store/utils/api';

export default {
  components: {
    NextButton,
    NextInput,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      accountSID: '',
      apiKeySID: '',
      authToken: '',
      medium: this.type,
      channelName: '',
      messagingServiceSID: '',
      useMessagingService: false,
      useAPIKey: false,
      phoneNumber: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
    authTokeni18nKey() {
      return this.useAPIKey ? 'API_KEY_SECRET' : 'AUTH_TOKEN';
    },
  },
  validations() {
    let validations = {
      channelName: { required },

      authToken: { required },
      accountSID: { required },
      medium: { required },
    };
    if (this.phoneNumber) {
      validations = {
        ...validations,
        phoneNumber: { required, isPhoneE164OrEmpty },
        messagingServiceSID: {},
      };
    } else {
      validations = {
        ...validations,
        messagingServiceSID: { required },
        phoneNumber: {},
      };
    }

    if (this.useAPIKey) {
      validations = {
        ...validations,
        apiKeySID: { required },
      };
    }
    return validations;
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const twilioChannel = await this.$store.dispatch(
          'inboxes/createTwilioChannel',
          {
            twilio_channel: {
              name: this.channelName?.trim(),
              medium: this.medium,
              account_sid: this.accountSID,
              api_key_sid: this.apiKeySID,
              auth_token: this.authToken,
              messaging_service_sid: this.messagingServiceSID,
              phone_number: this.messagingServiceSID
                ? null
                : `+${this.phoneNumber.replace(/\D/g, '')}`,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: twilioChannel.id,
          },
        });
      } catch (error) {
        const errorMessage =
          parseAPIErrorResponse(error) ||
          this.$t('INBOX_MGMT.ADD.TWILIO.API.ERROR_MESSAGE');
        useAlert(errorMessage);
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-5" @submit.prevent="createChannel()">
    <fieldset class="min-w-0 p-5 border rounded-xl border-n-weak bg-n-solid-1">
      <div class="flex flex-col gap-4">
        <NextInput
          v-model="channelName"
          :label="$t('INBOX_MGMT.ADD.TWILIO.CHANNEL_NAME.LABEL')"
          :placeholder="$t('INBOX_MGMT.ADD.TWILIO.CHANNEL_NAME.PLACEHOLDER')"
          :message="
            v$.channelName.$error
              ? $t('INBOX_MGMT.ADD.TWILIO.CHANNEL_NAME.ERROR')
              : ''
          "
          :message-type="v$.channelName.$error ? 'error' : 'info'"
          @blur="v$.channelName.$touch"
        />

        <NextInput
          v-if="useMessagingService"
          v-model="messagingServiceSID"
          :label="$t('INBOX_MGMT.ADD.TWILIO.MESSAGING_SERVICE_SID.LABEL')"
          :placeholder="
            $t('INBOX_MGMT.ADD.TWILIO.MESSAGING_SERVICE_SID.PLACEHOLDER')
          "
          :message="
            v$.messagingServiceSID.$error
              ? $t('INBOX_MGMT.ADD.TWILIO.MESSAGING_SERVICE_SID.ERROR')
              : ''
          "
          :message-type="v$.messagingServiceSID.$error ? 'error' : 'info'"
          @blur="v$.messagingServiceSID.$touch"
        />

        <NextInput
          v-else
          v-model="phoneNumber"
          :label="$t('INBOX_MGMT.ADD.TWILIO.PHONE_NUMBER.LABEL')"
          :placeholder="$t('INBOX_MGMT.ADD.TWILIO.PHONE_NUMBER.PLACEHOLDER')"
          :message="
            v$.phoneNumber.$error
              ? $t('INBOX_MGMT.ADD.TWILIO.PHONE_NUMBER.ERROR')
              : ''
          "
          :message-type="v$.phoneNumber.$error ? 'error' : 'info'"
          @blur="v$.phoneNumber.$touch"
        />

        <label
          for="useMessagingService"
          class="flex items-center gap-2 text-sm cursor-pointer text-n-slate-11"
        >
          <input
            id="useMessagingService"
            v-model="useMessagingService"
            type="checkbox"
            class="m-0"
          />
          {{
            $t(
              'INBOX_MGMT.ADD.TWILIO.MESSAGING_SERVICE_SID.USE_MESSAGING_SERVICE'
            )
          }}
        </label>

        <NextInput
          v-model="accountSID"
          :label="$t('INBOX_MGMT.ADD.TWILIO.ACCOUNT_SID.LABEL')"
          :placeholder="$t('INBOX_MGMT.ADD.TWILIO.ACCOUNT_SID.PLACEHOLDER')"
          :message="
            v$.accountSID.$error
              ? $t('INBOX_MGMT.ADD.TWILIO.ACCOUNT_SID.ERROR')
              : ''
          "
          :message-type="v$.accountSID.$error ? 'error' : 'info'"
          @blur="v$.accountSID.$touch"
        />

        <label
          for="useAPIKey"
          class="flex items-center gap-2 text-sm cursor-pointer text-n-slate-11"
        >
          <input
            id="useAPIKey"
            v-model="useAPIKey"
            type="checkbox"
            class="m-0"
          />
          {{ $t('INBOX_MGMT.ADD.TWILIO.API_KEY.USE_API_KEY') }}
        </label>

        <NextInput
          v-if="useAPIKey"
          v-model="apiKeySID"
          :label="$t('INBOX_MGMT.ADD.TWILIO.API_KEY.LABEL')"
          :placeholder="$t('INBOX_MGMT.ADD.TWILIO.API_KEY.PLACEHOLDER')"
          :message="
            v$.apiKeySID.$error ? $t('INBOX_MGMT.ADD.TWILIO.API_KEY.ERROR') : ''
          "
          :message-type="v$.apiKeySID.$error ? 'error' : 'info'"
          @blur="v$.apiKeySID.$touch"
        />

        <NextInput
          v-model="authToken"
          :label="$t(`INBOX_MGMT.ADD.TWILIO.${authTokeni18nKey}.LABEL`)"
          :placeholder="
            $t(`INBOX_MGMT.ADD.TWILIO.${authTokeni18nKey}.PLACEHOLDER`)
          "
          :message="
            v$.authToken.$error
              ? $t(`INBOX_MGMT.ADD.TWILIO.${authTokeni18nKey}.ERROR`)
              : ''
          "
          :message-type="v$.authToken.$error ? 'error' : 'info'"
          @blur="v$.authToken.$touch"
        />
      </div>
    </fieldset>

    <div class="flex justify-end">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.TWILIO.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
